import React from 'react';
import marked from 'marked';
import styles from './MarkdownViewer.module.scss';

export const MarkdownViewer = ({markdownText}) => {
    const renderMarkdown = (markdown) => {
        if (!markdown) {
            return {__html: ''};
        }
        return {__html: marked(markdown)};
    };

    return (
        <div className={styles.viewer}>
            <div className={styles.preview} dangerouslySetInnerHTML={renderMarkdown(markdownText)} />
        </div>
    );
};


